import axios from 'axios';
import { api } from "../utils/config";

const sendResponse = async (answer) => {
  
  try {

    const res = await axios.post(`${api}/answer/add`,
      answer,
      {withCredentials: true},
    );

    if(res.data){
      return res.data
    }else{
      return res.response.data;
    }

  } catch (error) {
    console.log(error);
  }
};

const getAnswersByChallengeId = async (userId,challengeId) => {
  
  try {

    const res = await axios.get(`${api}/answer/${userId}/${challengeId}`,
      {withCredentials: true},
    );

    if(res.data){
      return res.data
    }else{
      return res.response.data;
    }

  } catch (error) {
    console.log(error);
  }
};

const listChallengeWithStatus = async (userId) => {
  try {

      const res = await axios.get(`${api}/answer/status/${userId}`,
        {withCredentials: true},
      );

      if(res.data){
        return res.data
      }else{
        return res.response.data;
      }

  } catch (error) {
    console.error("Erro ao registrar:", error);
    throw error;
  }
};

const challengeAnswerService = {
  sendResponse,getAnswersByChallengeId,
  listChallengeWithStatus
}

export default challengeAnswerService;